"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.college = {
    CA: {
        instructions: "1215 Howe Ave. Sacramento, CA 95825",
        phone: "916-649-9600"
    },
    NV: {
        instructions: "6029 W. Charleston Blvd. Las Vegas, NV 89146",
        phone: "702-836-9900"
    },
    TX: {
        instructions: "9330 Lyndon B. Johnson Freeway Suite 650 Dallas, TX 75243",
        phone: "972-248-9000"
    },
    TX2: {
        instructions: "9330 Lyndon B. Johnson Freeway Suite 650 Dallas, TX 75243",
        phone: "972-248-9000"
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJIZWFkZXIuY29uZmlndXJhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Db21tb24vcGFydHMvQXNoZXJIZWFkZXIvQXNoZXJIZWFkZXIuY29uZmlndXJhdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLE9BQU8sR0FBRztJQUNuQixFQUFFLEVBQUU7UUFDQSxZQUFZLEVBQUUscUNBQXFDO1FBQ25ELEtBQUssRUFBRSxjQUFjO0tBQ3hCO0lBQ0QsRUFBRSxFQUFFO1FBQ0EsWUFBWSxFQUFFLDhDQUE4QztRQUM1RCxLQUFLLEVBQUUsY0FBYztLQUN4QjtJQUNELEVBQUUsRUFBRTtRQUNBLFlBQVksRUFBRSwyREFBMkQ7UUFDekUsS0FBSyxFQUFFLGNBQWM7S0FDeEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxZQUFZLEVBQUUsMkRBQTJEO1FBQ3pFLEtBQUssRUFBRSxjQUFjO0tBQ3hCO0NBQ0osQ0FBQSJ9